import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { loadCartData } from 'store/modules/cart';

import Footer from './Footer';
import Header from './Header';
import { Container } from './styles';

interface ILayoutProps {
  isHome?: boolean;
  initialPages?: boolean;
  children: React.ReactNode;
}

const Layout: React.FC<ILayoutProps> = ({
  isHome = false,
  initialPages = false,
  children,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCartData({ showMiniCart: false }));
  }, [dispatch]);

  return (
    <Container className={`layout${isHome ? ' layout-home' : ''}`}>
      <Header initialPages={initialPages} showNavigationSection={isHome} />
      <div id="height-swap" />
      <main>{children}</main>
      <Footer initialPages={initialPages} />
    </Container>
  );
};

export default Layout;
